import { http } from './HttpService.js'

export default {
	load(params = '') {
		return http.get('categorias' + params)
	},
	update(data) {
		let params = data.codigo
		return http.post('categorias/' + params, data)
	},
	create(data) {
		return http.post('categorias/create', data)
	},
	destroy(codigo) {
		return http.delete('categorias/' + codigo)
	},
}